import React from 'react';
import { InnerTooltipDetailHTML } from '@bbkAdminComponents/tooltips/detail-tooltip-inner-html';
import { cs } from '@bbkAdminUtils/css-utils';

type TooltipProps = React.ComponentProps<typeof InnerTooltipDetailHTML>;
type Props = {
  styles?: React.CSSProperties;
  tooltipProps?: TooltipProps;
};
export const ChartTooltip: React.FC<Props> = ({ styles, tooltipProps }) => (
  <div
    className={cs(
      'tw-pointer-events-none tw-absolute tw-z-[2000]',
      '-tw-mt-4 -tw-translate-x-1/2 -tw-translate-y-full tw-p-4',
      'tw-border tw-border-cbrneutral-200 tw-bg-white tw-text-cbrneutral-700',
      'tw-opacity-1 tw-rounded tw-shadow-2xl tw-transition-all'
    )}
    style={styles}
  >
    <InnerTooltipDetailHTML {...tooltipProps} />
    <div
      className={cs(
        'tw-pointer-events-none tw-absolute',
        'tw-right-1/2 -tw-mr-2 tw-translate-y-4',
        'tw-border-x-8 tw-border-t-8 tw-border-x-transparent tw-border-t-white'
      )}
    />
  </div>
);
